import { MODULE_LINK_TYPE, MT_MODULES } from '../constants';
export const ADMIN = {
  [MODULE_LINK_TYPE.BUILD]: (moduleId: string, seriesId: string) =>
    `/ui/coaching/${MT_MODULES.AI_ROLEPLAY}/admin/${seriesId}/${moduleId}/build`,
  [MODULE_LINK_TYPE.INVITE_TRACK]: (moduleId: string, seriesId: string) =>
    `/ui/coaching/${MT_MODULES.AI_ROLEPLAY}/admin/${seriesId}/${moduleId}/invite-track`,
  [MODULE_LINK_TYPE.ANALYTICS]: (moduleId: string, seriesId: string, moduleName: string) =>
    `modules/${moduleId}/mission/ai_roleplay/overview?gameType=ai_roleplay&inSeries=${seriesId}&name=${moduleName}`,
};

export const LEARNER = {};
